<template>
    <div style="display: flex; align-items: center; gap: 11px;">
        <div style="width: 30px; height: 30px; border-radius: 5px; border: 1px solid #d9d9d9; display: flex; justify-content: center; align-items: center;">
            <img v-if="!isUsePoint" style="width: 12px;" :src="require('@/assets/img/accumulate_point.png')" alt="">
            <img v-else style="width: 12px;" :src="require('@/assets/img/use_point.png')" alt="">
        </div> 
        <div style="flex: 1;">
            <div style="display: flex; font-weight: 700; align-items: center; gap: 5px;">
                <div style="font-size: 14px; line-height: 22px;">{{ pointTypeTransToText(recentActivityEach.point_type) }}</div>
                <div v-if="!isUsePoint" style="padding: 0 5px; line-height: 16px; font-size: 12px; color: #fff; background-color: var(--color-main); border-radius: 4px;">적립</div>
                <div v-else style="padding: 0 5px; line-height: 16px; font-size: 12px; color: #fff; background: #708090D4; border-radius: 4px;">사용</div>
            </div>
            <div style="font-weight: 400; font-size: 12px; line-height: 20px; color: #8d8d8d;">{{ $Util.getMDDHangulStr(recentActivityEach.insert_date) }}</div>
        </div>
        <div v-if="!isUsePoint" style="font-weight: 700; color: var(--color-main);">+{{ recentActivityEach.point }}</div>
        <div v-else style="font-weight: 700; color: #708090;">{{ recentActivityEach.point }}</div>
    </div>
</template>

<script>
import { POINT_HISTORY_TYPE } from '@/Constants';


export default {
    name: 'RecentActivityWrap',
    props: {
        recentActivityEach: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            POINT_HISTORY_TYPE: POINT_HISTORY_TYPE
        }
    },
    computed: {
        isUsePoint() {
            if (parseInt(this.recentActivityEach.point) > 0) {
                return false
            } else {
                return true
            }
        }
    },
    methods: {
        pointTypeTransToText(pointType) {
            if (pointType == 0) {
                return '내 프로필 설정하기'
            } else if (pointType == 1) {
                return '포지션 찾기'
            } else if (pointType == 2) {
                return '댓글 달기'
            } else if (pointType == 3) {
                return '친구 초대하기'
            } else if (pointType == 4) {
                return '훈련 하기'
            } else if (pointType == 5) {
                return '월간 완주 보너스'
            } else if (pointType == 6) {
                return '출석 체크'
            }
        }
    }
}
</script>

<style scoped>

</style>